import React from 'react'
import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs'
import AepsXpressFill from './aepsXpressFill/AepsXpress'
import AepsXpressList from './aepsXpressList/AepsXpressList'

function AepsXpressRep() {
  return (
    <>
    <Breadcrumbs breadCrumbsTitle={""}/>
    <AepsXpressFill/>
    <AepsXpressList/>
    </>
  )
}

export default AepsXpressRep